var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScissorsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.747442
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#232586",
    style: {
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_10488",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_10488)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5595 20.7661C29.3817 19.9135 29.9342 19.0751 30.7924 18.8979C31.6516 18.7227 32.4945 19.2702 32.6729 20.1233L36.3399 37.6553C36.4586 38.2221 37.0165 38.587 37.5881 38.4685C37.7396 38.4376 37.8747 38.3741 37.9918 38.2892C38.3344 38.1518 38.5967 37.8424 38.6468 37.4523L40.9384 19.4789C40.9917 19.0604 41.2055 18.6876 41.5411 18.4291C41.8773 18.1706 42.2937 18.0568 42.7149 18.1108C43.1361 18.1638 43.5113 18.3767 43.7715 18.7102C44.0317 19.0431 44.1457 19.4574 44.0924 19.8758L41.8277 37.6406C41.7755 38.0496 41.9702 38.4302 42.2943 38.6436C42.4927 38.8885 42.7867 39.0411 43.106 39.0411C43.6881 39.0411 44.1616 38.5708 44.1616 37.9924V36.6815C44.1616 35.6696 44.9907 34.8463 46.0088 34.8463C47.0274 34.8463 47.856 35.6696 47.856 36.6815V40.0898C47.856 40.6681 48.3299 41.1385 48.9116 41.1385C49.4937 41.1385 49.9671 40.6681 49.9671 40.0898V38.1786C50.1418 38.1015 50.5888 37.9924 50.8532 37.9924C51.6064 37.9924 52.2666 38.6048 52.2666 39.3033C52.2666 44.1723 51.8661 52.6929 50.792 54.827C49.2192 57.9526 47.4596 60.5398 41.8304 60.5398C36.6729 60.5398 32.2021 58.0994 29.2418 53.6677C27.3513 50.8378 26.4926 45.0228 29.4503 42.3523C29.7506 42.0812 30.367 41.7126 30.4721 41.6502L31.2072 46.695C31.2838 47.2172 31.735 47.5937 32.2507 47.5937C32.3008 47.5937 32.352 47.59 32.4032 47.5832C32.9801 47.4998 33.3801 46.9681 33.2967 46.395L29.5706 20.829L29.5595 20.7661ZM50.8189 35.8945C50.6184 35.8945 50.2627 35.9344 49.8431 36.0408C49.5317 34.1705 47.8745 32.7484 45.937 32.7484C45.4588 32.7484 44.9891 32.8444 44.5463 33.0106L46.1866 20.1395C46.3112 19.1653 46.0457 18.201 45.4398 17.425C44.8345 16.6484 43.961 16.1535 42.9804 16.0302C41.9993 15.9054 41.0292 16.1697 40.2476 16.7717C39.4664 17.3731 38.9677 18.2414 38.8437 19.2156L37.2514 31.7045L34.7397 19.6965C34.3248 17.7118 32.3615 16.4319 30.3633 16.8445C28.3768 17.2546 27.0922 19.1852 27.4859 21.1589L30.129 39.2965C29.2566 39.7752 28.2348 40.4967 28.1799 40.536C25.0476 42.775 24.0495 49.6486 27.5091 54.826C30.8732 59.8628 35.9636 62.6366 41.8425 62.6366C48.6593 62.6366 50.9377 59.2415 52.6873 55.764C54.3624 52.436 54.3814 39.8376 54.3814 39.3033C54.3814 37.456 52.7501 35.895 50.8189 35.8945Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScissorsIcon);
export default __webpack_public_path__ + "static/media/scissors_icon.b08cfb89dc81a433e831d7869408acd5.svg";
export { ForwardRef as ReactComponent };